(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pdo-home-manufacturers"] && !Shopify.designMode) return;
  try {
    function initializePdoBrandFilter() {
    const input = document.getElementById('pdo-step2-brand-filter');
    const grid = document.getElementById('pdo-repaired-brand-grid');
    const emptyMessage = document.getElementById('pdo-brand-no-results');
    if (!input || !grid || !emptyMessage || input.dataset.pdoFilterReady) return;
    input.dataset.pdoFilterReady = 'true';
    const normalize = (value) => value.toLowerCase().replace(/[^a-z0-9]/g, '');
    function filterBrands() {
      const query = normalize(input.value);
      let matches = 0;
      grid.querySelectorAll('[data-pdo-brand-card]').forEach((card) => {
        const label = card.querySelector('strong');
        const match = normalize(label ? label.textContent : '').includes(query);
        card.hidden = !match;
        if (match) matches += 1;
      });
      emptyMessage.hidden = matches > 0;
    }
    input.addEventListener('input', filterBrands);
    filterBrands();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializePdoBrandFilter);
  } else {
    initializePdoBrandFilter();
  }
  document.addEventListener('shopify:section:load', initializePdoBrandFilter);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdo-phase3-product-conversion"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', function (event) {
    const selector = event.target;
    if (!(selector instanceof HTMLSelectElement) || !selector.id.startsWith('SingleOptionSelector-')) return;
    const section = selector.closest('[data-section-type="product"]');
    if (!section) return;
    const data = document.getElementById('ProductJson-' + section.dataset.sectionId);
    if (!data) return;
    let product;
    try {
      product = JSON.parse(data.textContent);
    } catch (error) {
      return;
    }
    const options = Array.from(section.querySelectorAll('select[id^="SingleOptionSelector-"]'), function (option) {
      return option.value;
    });
    const variant = product.variants.find(function (candidate) {
      return candidate.options.length === options.length && candidate.options.every(function (value, index) {
        return value === options[index];
      });
    });
    if (!variant) return;
    const url = new URL(window.location.href);
    if (url.searchParams.get('variant') === String(variant.id)) return;
    url.searchParams.set('variant', String(variant.id));
    event.stopImmediatePropagation();
    window.location.assign(url.href);
  }, true);
  } catch(e) { console.error(e); }
})();

})();
